import { render, staticRenderFns } from "./AddEPaper.vue?vue&type=template&id=7c7c3815&scoped=true"
import script from "./AddEPaper.vue?vue&type=script&lang=js"
export * from "./AddEPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7c3815",
  null
  
)

export default component.exports